var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("元件載入錯誤，請重新整理瀏覽器")])}
var staticRenderFns = []

export { render, staticRenderFns }